import React from "react";
import "./waitLoading.css";

function WaitLoading() {
  return (
    <div className="waitloader-container">
      <div className="waitloader"></div>
    </div>
  );
}

export default WaitLoading;
